export default __webpack_public_path__ + "static/header-iconic-link-solutions-icon3.url-e258bbf55ce7200a4834a5d63e8dcb43.svg";